import { useAuth0 } from "@auth0/auth0-react"
import { useCallback, useEffect, useState } from "react"

export const useRemoveFeatureFromOrg = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [isError, setIsError] = useState(false)
	const { getAccessTokenSilently } = useAuth0()

	const removeFeatureFromOrg = useCallback(
		async (orgID, featureID) => {
			setIsLoading(true)
			return fetch(
				new Request(process.env.REACT_APP_SESSION_ADDR + "/api/v2/org/" + orgID + "/feature/" + featureID, {
					method: "DELETE",
					headers: new Headers({
						"authorization": "Bearer " + (await getAccessTokenSilently()),
						"Content-Type": "application/json"
					}),
					body: JSON.stringify({ org_id: orgID, feature_id: featureID })
				})
			)
				.then((response) => {
					if (response.ok) {
						return response
					} else if (response.statusText === "Unauthorized") {
						throw new Error("Unauthorized")
					} else {
						console.log(response.statusText)
						throw new Error("Something went wrong")
					}
				})
				.catch((error) => {
					setIsError(true)
					console.error("Error: ", error)
				})
				.finally(() => {
					setIsLoading(false)
				})
		},
		[getAccessTokenSilently]
	)

	useEffect(() => {
		return () => {
			setIsLoading(null)
			setIsError(null)
		}
	}, [])

	return { isLoading, isError, setIsError, removeFeatureFromOrg }
}
